import slideInBlock from './modules/slideInBlock'

const bgSlideBlock = slideInBlock();

export default () => {

  const a = {};
  const init = () => {
    console.log('init accessSec');
    a.root = document.getElementById('access');
    if (!a.root) {
      return;
    }

    bgSlideBlock.init(a.root.querySelector('.l-section__bg'));

    window.addEventListener('scroll', scrollBehivior);
    scrollBehivior();
  }

  const scrollBehivior = () => {
    if (a.root.getBoundingClientRect().y < (window.innerHeight / 2)) {
      bgSlideBlock.move();
      window.removeEventListener('scroll', scrollBehivior)
    }
  }

  init();

  return {}
}
